"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSearch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var styles_1 = require("../../styles");
var _1 = require("./");
var SearchWrapper = (0, styled_components_1.default)(framer_motion_1.motion.div)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  grid-column: 1 / span 4;\n  height: 50px;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n\n  ", "\n\n  ", "\n\n  button {\n    left: 0;\n    opacity: .5;\n    position: absolute;\n    top: 58%;\n    transform: translateY(-50%);\n    transition: 300ms opacity ease-in-out;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    ", "\n  }\n\n  .klk {\n    overflow: hidden;\n  }\n\n  .inp-search {\n    label {\n      display: none;\n    }\n\n    input {\n      padding-left: 30px;\n      padding-top: 8.5px;\n    }\n  }\n"], ["\n  grid-column: 1 / span 4;\n  height: 50px;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n\n  ", "\n\n  ", "\n\n  button {\n    left: 0;\n    opacity: .5;\n    position: absolute;\n    top: 58%;\n    transform: translateY(-50%);\n    transition: 300ms opacity ease-in-out;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    ", "\n  }\n\n  .klk {\n    overflow: hidden;\n  }\n\n  .inp-search {\n    label {\n      display: none;\n    }\n\n    input {\n      padding-left: 30px;\n      padding-top: 8.5px;\n    }\n  }\n"])), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 60px;\n  "], ["\n    height: 60px;\n  "]))), styles_1.mq.greaterThan('desktop-xs')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    grid-column: 1 / span 3;\n  "], ["\n    grid-column: 1 / span 3;\n  "]))), function (_a) {
    var isActive = _a.isActive;
    return isActive && "opacity: 1;";
});
var variantsInp = {
    'active': {
        width: 'auto',
        transition: {
            type: 'tween',
            duration: .3,
            ease: [.25, .1, .25, 1]
        }
    },
    'inactive': {
        width: '0',
        transition: {
            type: 'tween',
            duration: .3,
            ease: [.25, .1, .25, 1]
        }
    }
};
var TIMEOUT_ID = null;
var InputSearch = function (_a) {
    var onSearch = _a.onSearch;
    var _b = __read((0, react_1.useState)(false), 2), inputVisible = _b[0], setInputVisible = _b[1];
    var handleSearch = function (value) {
        onSearch && onSearch(value);
    };
    var changeState = function (newState) { return function () {
        setInputVisible(newState);
    }; };
    var handleInputChange = function (value) {
        TIMEOUT_ID && clearTimeout(TIMEOUT_ID);
        TIMEOUT_ID = setTimeout(function () { return handleSearch(value); }, 300);
    };
    return ((0, jsx_runtime_1.jsxs)(SearchWrapper, __assign({ isActive: inputVisible }, { children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, __assign({ className: 'klk', variants: variantsInp, animate: inputVisible ? 'active' : 'inactive' }, { children: (0, jsx_runtime_1.jsx)(_1.Input, { onChange: handleInputChange, autofocus: inputVisible, className: 'inp-search', onBlur: changeState(false), type: 'search', label: 'Buscar' }) })), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: changeState(true) }, { children: (0, jsx_runtime_1.jsx)("img", { src: 'images/icon-search.svg', alt: 'icon search' }) }))] })));
};
exports.InputSearch = InputSearch;
var templateObject_1, templateObject_2, templateObject_3;
